import { StatusChipVariant } from '@occc-app/design-system';
import { SurveyQuestionFragment, SurveyStatus } from '@occc/graphql';

import { GeneralSurveyQuestionType } from './types';

export const titleByStatus: Record<SurveyStatus, string> = {
  [SurveyStatus.Active]: 'Active',
  [SurveyStatus.Archived]: 'Archived',
  [SurveyStatus.Draft]: 'Draft',
  [SurveyStatus.Expired]: 'Expired',
};

export const chipVariantByStatus: Record<SurveyStatus, StatusChipVariant> = {
  [SurveyStatus.Active]: 'success',
  [SurveyStatus.Archived]: 'error',
  [SurveyStatus.Draft]: 'default',
  [SurveyStatus.Expired]: 'error',
};

export const titleByQuestionTypeName: Record<SurveyQuestionFragment['__typename'], string> = {
  SurveyQuestionSingleChoice: 'Single choice',
  SurveyQuestionMultipleChoice: 'Multiple choice',
  SurveyQuestionIntSlider: 'Slider',
};

export const GENERAL_SURVEY_STATUS_ALL = 'ALL';

export const STATUS_PARAM = 'status';

export const statusFilterOptions = [
  { label: 'All', value: GENERAL_SURVEY_STATUS_ALL },
  { label: 'Active', value: SurveyStatus.Active },
  { label: 'Draft', value: SurveyStatus.Draft },
  { label: 'Archived', value: SurveyStatus.Archived },
  { label: 'Expired', value: SurveyStatus.Expired },
];

export const surveyTypeOptions: {
  label: string;
  value: GeneralSurveyQuestionType;
}[] = [
  { label: 'Single choice', value: 'SurveyQuestionSingleChoice' },
  { label: 'Multiple choice', value: 'SurveyQuestionMultipleChoice' },
  { label: 'Slider', value: 'SurveyQuestionIntSlider' },
];

export enum SurveyTabs {
  Configure = 'configure',
  Target = 'target',
  Schedule = 'schedule',
}

const SURVEY_LOCATIONS_PREFIX = 'locations';

export const SURVEY_LOCATIONS_PAGE_SIZE = 8;
export const SURVEY_LOCATIONS_AFTER_PARAM = `${SURVEY_LOCATIONS_PREFIX}-after`;
export const SURVEY_LOCATIONS_BEFORE_PARAM = `${SURVEY_LOCATIONS_PREFIX}-before`;
export const SURVEY_LOCATION_SORT_FIELD_PARAM = `${SURVEY_LOCATIONS_PREFIX}-sort-field`;
export const SURVEY_LOCATION_SORT_DIRECTION_PARAM = `${SURVEY_LOCATIONS_PREFIX}-sort-direction`;

export const MAX_DATE_RANGE_DAYS = 400;
